import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {ProvidersDentalGuide} from 'domain/usecases/private/guide-flow/dental-guide/post-providers';
import {useQueryParams} from 'presentation/pages/private';
import {UseOdontoProvidersQueryParams} from './types';
import {getOdontoProviders} from '../../services/getOdontoProviders';
import {GuideStep} from 'presentation/modules/guide/shared/constants/constants';

export function useOdontoProvidersQuery({
	type,
	cdEspecialidade,
	dsTipo,
	filtroBairro,
	coordenadas,
}: UseOdontoProvidersQueryParams) {
	const {SEARCH_PARAMS} = useQueryParams();
	const {step, ufCode, cityName} = SEARCH_PARAMS;

	return useQuery<ProvidersDentalGuide[]>({
		queryKey: [
			QUERY_KEYS.ODONTO_PROVIDERS_GUIDE,
			{
				cdEspecialidade,
				dsTipo,
				type,
				filtroBairro,
				coordenadas,
				ufCode,
				cityName,
			},
		],
		queryFn: ({signal}) =>
			getOdontoProviders({
				...(coordenadas && {nmLocal: coordenadas}),
				...(coordenadas && {distancia: '50'}),
				tpLocalidade: coordenadas ? 'Coordenadas' : 'Cidade',
				cdEspecialidade,
				dsTipo,
				filtroBairro: filtroBairro || [],
				signal,
			}),
		enabled:
			Boolean((ufCode && cityName) || coordenadas) && Boolean(step === GuideStep.RESULTS),
	});
}
